import React, { useState, useEffect, useCallback } from 'react';
import { Button } from 'reactstrap';
import { createFacebookFeed, getFacebookUrl, getFacebookPreview, getDataForFacebookAutocomplete } from 'utils/api'
import { toast } from 'react-toastify';
import { textTruncateByWords, checkPermissions } from 'utils/other';
import Loader from 'components/Loader';
import InputField from './components/InputField';
import Header from './components/Header';
import Preview from './components/Preview';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sortObjects} from 'Helpers/sortObjects';
import SpinnerButton from 'components/SpinnerButton';

function FacebookInput({ ...props }) {
    let history = useHistory();

    const [loading, setLoading] = useState(true);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [creationLoading, setCreationLoading] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userData, setUserData] = useState('');
    const [feed, setFeed] = useState(null);
    const [name, setName] = useState('');
    const [feedId, setFeedId] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [autocompleteData, setAutocompleteData] = useState(null);
    const [autocompleteId, setAutocompleteId] = useState(null);
    const [publicPageData, setPublicPageData] = useState(null);

    useEffect(() => {
        // async function updPermissions() {
        //     let updatedUserData = await getPermissions();
        //     let updatedPermissions = updatedUserData.content.permissions;
            
        //     console.log(updatedPermissions)
        //     console.log(props.auth.permissions)
        //     console.log(comparePermissionArr(updatedPermissions, props.auth.permissions))

        //     if(!comparePermissionArr(updatedPermissions, props.auth.permissions)) { 
        //         updatePermissions(updatedUserData.content)
        //     } 
        //     if(updatedPermissions && updatedPermissions.includes('social')) {
        //         getUserDataFromFacebook();
        //     }
        // }
        checkPermissions(props.auth.permissions, getUserDataFromFacebook, 'social');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const getPreview = async (value) => {
        setPreviewLoading(true);
        let pathValue;
        if(autocompleteData && autocompleteId) {
            pathValue = autocompleteData.find(item => item.id === autocompleteId).link;
        } else {
            pathValue = value;
        }
        const params = {
            account_id: parseInt(userData.id),
            url: pathValue.trim(),
        }
        try {
            let source = await getFacebookPreview(feedId, params);
            setIsAutocompleteOpen(false);
            let previewData = [...source.content.news];
            setPublicPageData({
                facebookPageId: source.content.pageId,
                pagePictureUrl: source.content.pictureUrl,
                about: source.content.about,
                link: source.content.url,
                title: source.content.title,
                followersCount: source.content.followers,
                screenName: source.content.screenName,
                sourceUrl: source.content.url, 
            });
            setName(source.content.title);
            /*source.sort((a, b) => {
                if (b.publishedAt === null || a.publishedAt === null || b.abstract === null || a.abstract === null) {
                    return 0;
                }

                return b.publishedAt.date.localeCompare(a.publishedAt.date);
            });*/
            
            if (previewData.length > 100) {
                previewData = previewData.slice(0, 100);
            }
            let sortedByDate = sortObjects(previewData, 'publishedAt', 'desc')
            setFeed(sortedByDate);
            setPreviewLoading(false);
        } catch (e) {
            setPreviewLoading(false);
            setIsAutocompleteOpen(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
            }
            throw e.message;
        }
    };
    
    const getUserDataFromFacebook = async () => {
        setLoading(true);
        try {
            let facebookUrl = await getFacebookUrl();
            if (facebookUrl.hasOwnProperty('id')) {
                setUserData(facebookUrl);
                setIsAuthenticated(true);
            } else if (facebookUrl.hasOwnProperty('url')) {
                setUserData(facebookUrl);
                setIsAuthenticated(false);
            } else {
                console.log('Error: no url or id found')
            }
            setLoading(false);
        } catch (err) {
            console.log(err);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
            setLoading(false);
        }
    }

    const redirectToFacebookLogin = async () => {
        await getUserDataFromFacebook();
        setLoading(true);
        if(userData.hasOwnProperty('url')){
            window.location.assign(userData.url);
        } else {
            setLoading(false);
        }
    }

    const submitUrl = () => {
        setCreationLoading(true);
        
        let pathValue;
        if(autocompleteData && autocompleteId) {
            pathValue = autocompleteData.find(item => item.id === autocompleteId).link;
        } else {
            pathValue = publicPageData.link;
        }
        const params = {
            account_id: userData.id,
            url: pathValue.trim(),
            title: name.trim(),
            //facebookPageId: publicPageData.facebookPageId,
            //feedName: name.trim(),
            //followersCount: publicPageData.followersCount,
            //screenName: publicPageData.screenName,
            //sourceUrl: publicPageData.sourceUrl, 
        }
        
        // if(feedId){
        //     updateFacebookFeed(params, feedId)
        //         .then(() => {
        //             setCreationLoading(false);
        //             history.push('/feeds/fetches');
        //         })
        //         .catch((err) => {
        //             setCreationLoading(false);
        //             if(err.message && err.message.length < 150) {
        //                 toast.error(err.message);
        //             }
        //             getUserDataFromFacebook();
        //         });
        // } else {
            createFacebookFeed(params)
                .then(() => {
                    setCreationLoading(false);
                    history.push('/feeds/fetches');
                })
                .catch((err) => {
                    setCreationLoading(false);
                    if(err.message && err.message.length < 150) {
                        toast.error(err.message);
                    }
                    getUserDataFromFacebook();
                });
        //}
    }

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            const context = this;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                func.apply(context, args);
            }, wait);
        };
    }

    const getAutocomplete = (val, userId) => {
        const params = {
            accountId: userId,
            title: val,
        }
        getDataForFacebookAutocomplete(params)
            .then(data => {
                setAutocompleteData(data.content);
                setIsAutocompleteOpen(true);
            })
            .catch((err) => {
                console.log('error: ', err.message);
                //toast.error(error.message);
            });
    };

    const debouncedAutocomplete = useCallback(debounce(getAutocomplete, 500), []);

    const handleInputChange = (value, isAutocomplete) => {
        setInputValue(value);
        let isIncludeUrl = value.trim().includes('https://facebook.com') || value.trim().includes('https://www.facebook.com');
        if(!isAutocomplete && !isIncludeUrl && value.trim() !== '') {
            debouncedAutocomplete(value, userData.id);
        } else {
            setIsAutocompleteOpen(false);
        }
        if(autocompleteId) { 
            setAutocompleteId(null);
        }
    };
    
    const changeInputToAutocomplete = (value, id) => {
        handleInputChange(value, true);
        setIsAutocompleteOpen(false);
        setAutocompleteId(id);
        getPreview(value);
        //document.getElementById('facebook-input').focus();
    }

    const cleanPreview = () => {
        handleInputChange('');
        setFeed(null);
    }

    return props.auth.permissions && !props.auth.permissions.includes('social') ?
            <>
                <Header text="Fetch posts from Facebook" />
                <div style={{ fontSize: '18px' }}>
                    To follow Facebook public pages,<br/> contact Support to access this feature<br/>
                    <a style={{ textDecoration: 'underline' }} href="mailto:support@newsfetch.io">
                        support@newsfetch.io
                    </a>
                </div>
            </>
    : loading ? (
            <div>
                <Loader small text="Checking Facebook authorization"/>
            </div>
        ) : (
        <>
            <Header text="Fetch posts from Facebook" />
            {isAuthenticated ? (
                <>
                    <div style={{ margin: '5px 0' }}>
                        &nbsp;Hello, <span style={{ color: '#4267B2' }}>{userData.name}</span>
                    </div>
                    <InputField 
                        onSubmit={getPreview} 
                        parrentDataHandling={true}
                        value={inputValue} 
                        handleChange={handleInputChange}
                        loading={previewLoading}
                        inputPlaceholder="Enter the Facebook public page URL"
                        showSubmitGlass={true}
                        cleanPreview={cleanPreview}
                    />
                    {isAutocompleteOpen && autocompleteData && autocompleteData.length > 0 && inputValue.trim().length > 0 &&
                        <div style={{ width: '100%', border: '1px solid #e4e7ea', borderRadius: '.25rem' }}>
                            {autocompleteData.map(item =>
                                <div onClick={() => changeInputToAutocomplete(item.link, item.id)} className="facebook-autocomplete-item">
                                    <div style={{ fontWeight: '700' }}>{item.name}</div>
                                    <div>{item.link}</div>
                                </div>
                            )}
                        </div>
                    }
                    {feed && 
                        <div className="preview-container">
                            {previewLoading ? (
                                <div>
                                    <i className="fa fa-spinner fa-spin" />
                                </div>
                            ) : (
                                <>
                                    <div className="twitter-input_container">
                                        <InputField 
                                            onSubmit={submitUrl} 
                                            inputPlaceholder="Enter the Newsfeed name"
                                            showSubmitGlass={false}
                                            parrentDataHandling={true}
                                            value={name} 
                                            handleChange={setName}
                                        />
                                        <div className="twitter-input_dropdown">
                                            {/*<Button*/}
                                            {/*    disabled={name.trim() === ''} */}
                                            {/*    style={{ color: 'white', minWidth: '120px', margin: '0' }} */}
                                            {/*    onClick={submitUrl}*/}
                                            {/*    className="btn typical-button target_input-btn"*/}
                                            {/*>*/}
                                            {/*    {creationLoading ? */}
                                            {/*        <i className="fa fa-spinner fa-spin" />*/}
                                            {/*    :*/}
                                            {/*        'Create Fetch'*/}
                                            {/*    }*/}
                                            {/*</Button>*/}
                                            <SpinnerButton
                                                minWidth="125px"
                                                title="Create Source"
                                                submitting={creationLoading}
                                                onClick={submitUrl}
                                                disabled={name.trim() === ''}
                                            />
                                        </div>
                                    </div>
                                    {publicPageData &&
                                        <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
                                            <div style={{ height: '50px', marginRight: '10px' }}>
                                                <img style={{ borderRadius: '50%' }} src={publicPageData.pagePictureUrl} alt="public page"/>
                                            </div>
                                            <div>
                                                <div style={{ fontSize: '1.1rem', fontWeight: '500' }}>{publicPageData.title}</div>
                                                {publicPageData.about && <div>{textTruncateByWords(publicPageData.about)}</div>}
                                            </div>
                                        </div>
                                    }
                                    <Header text="Preview" />
                                    <Preview feed={feed} sourceType="facebook" />
                                </>
                            )}
                        </div>
                    }
                </>
            ) : (
                <>
                    <Button 
                        onClick={redirectToFacebookLogin} 
                        id="loginBtn" 
                        style={{ margin: '0', backgroundColor: '#4267B2', width: '190px' }}
                        className="btn btn-info target_input-btn"
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                flex: '100%'
                            }}>
                                <div>Login with Facebook</div>
                            </div>
                        </div>
                    </Button>
                </>
            )}
        </>
    );
}

const mapStateFromProps = (state) => ({
    auth: state.auth,
})

export default connect(mapStateFromProps, null)(FacebookInput);
